import * as angular from "angular";
import { House } from "../../models/house.model";
import { DialogUtils } from "../../helper/dialog.helper";

let LocationHousesComponent = {
    selctor: "vcLocationHouses",
    templateUrl: "/angular/components/house/location-houses.component.html",
    bindings: {
        coords: "<",
        filter: "<",
        close: "&",
        effort: "=",
        selectHouse: "&",
    },
    controller: class LocationHousesController {
        // * bindings for typescript compiler *
        public coords: any;
        public filter: any;
        public close: any;
        public effort: any;
        public selectHouse: any;
        // ************************************
        public houses?: any;
        public loading?: boolean;
        public isBuilding?: boolean;

        private readonly $scope: any;
        private readonly dialog: DialogUtils;
        private readonly $http: any;
        private readonly __env: any;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            $http: any,
            __env: any
        ) {
            this.$http = $http;
            this.__env = __env;
            this.$scope = $scope;
            this.dialog = DialogUtils;
        }

        housesOnMarker(): void {
            this.loading = true;
            this.$http
                .get(
                    this.__env.apiUrl() +
                        "/house/location/?lat=" +
                        this.coords.latitude +
                        "&lng=" +
                        this.coords.longitude +
                        "&effort=" +
                        this.effort.id +
                        "&filters=" +
                        JSON.stringify(this.filter.nonEmptyValues())
                )
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.houses = json.data;
                        this.isBuilding =
                            this.houses && this.houses[0] && this.houses[0].bid;
                    }
                    angular.forEach(this.houses, (house: any) => {
                        if (!house.color) house.color = "#8d8d8d";
                    });
                    this.loading = false;
                });
        }

        openBuildingDialog(bid: number, ev: object): void {
            this.dialog.show({
                component: "vc-view-building",
                targetEvent: ev,
                scope: this.$scope,
                ariaLabel: "Building",
                locals: {
                    bid: bid,
                },
                size: "large",
            });
        }

        $onChanges(): void {
            this.housesOnMarker();
        }

        houseClicked(house: House): void {
            this.selectHouse({ hid: house.hid });
        }
    },
};

angular
    .module("house")
    .component(LocationHousesComponent.selctor, LocationHousesComponent);
